import React from "react";
import ResultTable from "../ResultTable/ResultTable";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";
import NoResultsDisplay from "./NoResultsDisplay";
import {useGetSearchResultsQuery} from "../../store/Api";
import {INormalizedProduct} from "../../models/NormalizedProduct";
import { IFilledFilters, ISearchRequest } from "../../models/Search";
import {criteriaIsBlank} from "../../logic/Search";
import { ICollectionResponse } from "../../models/ICollectionResponse";
import { Spinner, SpinnerSize } from "@fluentui/react";
import {IProductBundleRef} from "../../models/ProductBundles";

export enum DisplayFormat {
    table,
    cards,
}

export interface IAlternativeCatalog {
    name: string;
    description: string;
    count: number;
}

interface IResultsDisplayProps {
    runningRealtime?: boolean;
    refreshingVendors?: string[];
    onDetailsSelection: (p: INormalizedProduct) => void;
    onFilterChange: (filters: IFilledFilters) => void;
    expandingSearch?: boolean;
    expandedResults?: ICollectionResponse<INormalizedProduct>;
    selectedBundle?: IProductBundleRef
    onSelectionChanged?: (products: INormalizedProduct[]) => void;
    selectionResetToken?: number;
    /** Where the column header sticks (px from the top); the page passes header + pinned bundle strip. */
    stickyTop?: number;
}


const ResultsDisplay: React.FC<IResultsDisplayProps> = (props) => {
    const catalog = useSelector((state: RootState) => state.search.selectedCatalog);
    const criteria = useSelector((state: RootState) => state.search.criteria);
    const products = useGetSearchResultsQuery({catalog: catalog?.name, criteria});
    const newCriteria : ISearchRequest = {
        keywords: criteria.keywords,
        inStock: criteria.inStock,
        manufacturer: [],
        vendor: [],
        must: [],
        boost: [],
        exclude: [],
        filters: [],
    }


    if (products.data?.total === 0 && (props.expandedResults?.items.length === 0 || props.expandingSearch)) {
        if (props.expandingSearch) {
            return <>
                <Spinner
                    size={SpinnerSize.large}
                    label='No Results Found. Expanding Search.'
                    labelPosition='bottom'
                    styles={{
                        root: { marginTop: '2em'},
                        label: { fontSize: '22px', height: '40px', marginTop: '0.5em' },
                        circle: { width: '75px', height: '75px', marginBottom: '2em', borderWidth: '5px' }
                    }}
                />
            </>
        }

        if(criteriaIsBlank(criteria))
            return <NoResultsDisplay message={"Begin a New Search"} criteria={newCriteria} onFilterChange={props.onFilterChange}/>;
        
        else 
            return <NoResultsDisplay criteria={newCriteria} onFilterChange={props.onFilterChange}/>;
    }

    return <ResultTable
        onDetailsSelection={props.onDetailsSelection}
        runningRealtime={props.runningRealtime}
        stickyTop={props.stickyTop}
        refreshingVendors={props.refreshingVendors}
        products={[...products.data?.products ?? [], ...(props.expandedResults?.items ?? [])]}
        isLoading={products.isFetching}
        selectedBundle={props.selectedBundle}
        onSelectionChanged={props.onSelectionChanged}
        selectionResetToken={props.selectionResetToken}
    />
};

export default ResultsDisplay;
